declare namespace newrelic {
  type SimpleType = string | number | boolean | null | Error;
  function noticeError(
    error: string | Error,
    errorDetailsObj?: Record<string, SimpleType>,
  ): void;
  function setCustomAttribute(
    attribute: string,
    value: SimpleType,
    persist?: boolean,
  ): void;
  function addPageAction(
    actionName: string,
    eventDetailsObj?: Record<string, SimpleType>,
  ): void;
}
declare const window: any;

export const logErrorToNewRelic = (
  error: string | Error,
  errorDetailsObj?: Record<string, newrelic.SimpleType> | undefined,
) => {
  if (window.newrelic) newrelic?.noticeError(error, errorDetailsObj);
};

export const logCustomAttributeToNewRelic = (
  attribute: string,
  value: newrelic.SimpleType,
  persist?: boolean,
) => {
  if (window.newrelic) newrelic?.setCustomAttribute(attribute, value, persist);
};

export const logPageActionToNewRelic = (
  actionName: string,
  eventDetailsObj?: Record<string, newrelic.SimpleType> | undefined,
) => {
  if (window.newrelic) newrelic?.addPageAction(actionName, eventDetailsObj);
};
